// extracted by mini-css-extract-plugin
export default {"wrapper":"layout_wrapper__efCnK","header":"layout_header__-e-av","navbar":"layout_navbar__oGt2Z","main":"layout_main__Rb0xp"};